import {
  SET_MATRIX_CHILDREN,
  SET_MATRIX_CHILD_PAGINATION,
} from '../constants/constant_action_types';

const INITIAL_STATE = {
  item: {},
  pagination: {
    page: 1,
    perPage: 10,
  },
};

export function matrixReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_MATRIX_CHILDREN: {
      return {
        ...state,
        item: action.data,
      };
    }

    case SET_MATRIX_CHILD_PAGINATION: {
      return {
        ...state,
        pagination: action.pagination,
      };
    }

    default:
      return state;
  }
}
